export default __webpack_public_path__ + "static/media/resourceForGettingStarted3.0089517e.png";